import { MinHeightSkeleton, TableGridRow } from './Styled';

type Props = {
  canManageSnippets: boolean;
  snippetRowGrid: string;
};

export const SnippetListSkeleton = ({ canManageSnippets, snippetRowGrid }: Props) => {
  return (
    <TableGridRow gridLayout={snippetRowGrid} data-test={`snippet-list-skeleton`}>
      <MinHeightSkeleton />
      <MinHeightSkeleton />
      <MinHeightSkeleton />
      {canManageSnippets && <MinHeightSkeleton />}
    </TableGridRow>
  );
};
